// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__es-Wz","fileBtn":"File_fileBtn__1L32X","closeBtn":"File_closeBtn__2mqK3","fileSelected":"File_fileSelected__E-RLB","disabled":"File_disabled__3m-SG"};